import "@mantine/dates/styles.css";
import React, { useEffect } from "react";
import { Route, useHistory } from "react-router-dom";
import ChecklistTemplateTestPage from "../ChecklistTemplateTestPage/ChecklistTemplateTestPage";
import ProjectIdUrlSync from "../ProjectIdInSync";
import { FailedAlert, NoAccess, SuccessMessage } from "../components";
import FailedMessage from "../components/FailedMessage";
import { useAppDispatch, useAppSelector } from "../hooks";
import { useTranslation } from "../i18n";
import "../styles/bootstrapCompatability.css";
import "../styles/app.css";
import DoksamChecklistPath from "./DoksamChecklistPath";
import DoksamReportPath from "./DoksamReportPath";
import { McAppShell } from "./McAppShell";
import OpenedAppModals from "./OpenedAppModals";
import ProjectApp from "./ProjectApp";
import RtkqPatchToast from "./RtkqPatchToast";
import { logicWhenAppStarts } from "./actions";
import MemberModal from "./routes/MemberModal";
import AcceptInvite from "./routes/accept-invite/AcceptInvite";
import Appadmin from "./routes/appadmin/Appadmin";
import Apptest from "./routes/apptest/Apptest";
import Login from "./routes/login/LoginNew";
import { PasswordReset } from "./routes/login/PasswordReset";
import { MyTasksPage } from "./routes/myTasks/MyTasksPage";
import { Projects } from "./routes/projects/MacProjects/Projects";
import ReportAdmin from "./routes/report/reportAdmin/ReportAdmin";
import ReportAdminPage from "./routes/report/reportAdmin/ReportAdminPage";
import ErrorPage from "./routes/stats/Errors/ErrorPage";
import { Stats } from "./routes/stats/Stats";
import { getProjectIdFromUrl } from "./utils";

const App: React.FC = () => {
  const history = useHistory();
  const currrentPath = history.location.pathname;
  const dispatch = useAppDispatch();

  const isProduction = useAppSelector((state) => state.globalReducer.isProduction);
  const user = useAppSelector((state) => state.globalReducer.user);
  const memberIdModal = useAppSelector((state) => state.globalReducer.memberIdModal);

  const projectId = getProjectIdFromUrl(currrentPath);

  const goToLink = localStorage.getItem("gotolink");

  const isPasswordResetPage = currrentPath?.includes("password-reset");

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    if (user != null && (currrentPath === "/" || currrentPath === "")) {
      history.push("/projects");
    }
  }, [user]);

  const init = () => {
    if (isPasswordResetPage === true) {
      localStorage.removeItem("gotolink");
    }
    if (goToLink != null && isPasswordResetPage === false) {
      console.log(`redirecting to ${goToLink}`);
      localStorage.removeItem("gotolink");
      history.push(goToLink);
    }
    dispatch(logicWhenAppStarts(history));
  };

  return (
    <>
      <OpenedAppModals />
      <SuccessMessage />
      <FailedMessage />
      <ProjectIdUrlSync />
      {memberIdModal && projectId != null && <MemberModal memberId={memberIdModal} projectId={projectId} />}
      <Route
        path={`/accept-invite/:userId/:code`}
        exact
        render={(props) => <AcceptInvite code={props.match.params.code} userId={props.match.params.userId} />}
      />
      <Route path="/no-access" component={NoAccess} />
      <Route path="/login" component={Login} />
      <Route path={`/password-reset/:userId/:code`} render={(props) => <PasswordReset match={props.match} />} />
      <Route exact path="/terminated" component={Terminated} />
      <>
        {user != null && (
          <>
            <Route
              path="/project/:projectId"
              render={() => {
                return (
                  <McAppShell>
                    <ProjectApp />
                  </McAppShell>
                );
              }}
            />
            <Route
              path="/projects"
              render={() => (
                <McAppShell>
                  <Projects />
                </McAppShell>
              )}
            />
            <Route
              exact
              path="/tasks"
              render={() => (
                <McAppShell>
                  <MyTasksPage />
                </McAppShell>
              )}
            />
            <Route exact path="/stats" component={Stats} />
            <Route exact path="/errors" component={ErrorPage} />
            <Route exact path="/test" component={Apptest} />
            <Route path={`/appadmin`} component={Appadmin} />
            <Route exact path="/reportadmin" component={ReportAdmin} />
            <Route
              path={`/reportadmin/:reportId`}
              render={(props) => <ReportAdminPage reportId={props.match.params.reportId} />}
            />

            <Route
              exact
              path={`/doksam/checklist`}
              render={(props) => <DoksamChecklistPath searchStr={props.location.search} />}
            />
            <Route
              exact
              path={`/doksam/report`}
              render={(props) => <DoksamReportPath searchStr={props.location.search} />}
            />
            {isProduction === false && (
              <Route exact path={`/checklist-template-test`} component={ChecklistTemplateTestPage} />
            )}
          </>
        )}
      </>
      {isProduction === false && <RtkqPatchToast />}
    </>
  );
};

export default App;

const Terminated: React.FC = () => {
  const t = useTranslation();

  return (
    <div className="d-flex flex-column gray-200 w-100 h-100 pt-5 align-content-center" style={{ width: "300px" }}>
      <FailedAlert title={t("app.terminated")} />
    </div>
  );
};
